import { every } from '@sama/micro-dash';
import {
  ShapeState,
  ShapeState3D,
} from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { ShapeGroupOrderState } from '../../../team-apis/content/content-connector';
import {
  PointCloudShapeType,
  pointCloudShapeTypes,
} from '../../../team-apis/otterdam/answers/point-cloud-answer';
import {
  Point2D,
  Point3D,
  VectorTaggingShapeType,
  vectorTaggingShapeTypes,
} from '../../../team-apis/otterdam/answers/shape-typings';

export function isShapeGroupOrderState2D(
  state: ShapeGroupOrderState,
): state is ShapeGroupOrderState<
  VectorTaggingShapeType,
  Point2D,
  ShapeState<Point2D, VectorTaggingShapeType>
> {
  return every(state.shapes, (shape) =>
    // @ts-ignore -- fix me
    vectorTaggingShapeTypes.includes(shape.type as VectorTaggingShapeType),
  );
}

export function isShapeGroupOrderState3D(
  state: ShapeGroupOrderState,
): state is ShapeGroupOrderState<PointCloudShapeType, Point3D, ShapeState3D> {
  return every(state.shapes, (shape) =>
    // @ts-ignore -- fix me
    pointCloudShapeTypes.includes(shape.type as PointCloudShapeType),
  );
}

export function createBlankShapeGroupOrderState() {
  return {
    shapes: {},
    groups: {},
    shapeAndGroupOrder: [],
  };
}
